import { Divider, Drawer, Typography } from "antd";
import moment from "moment";
import React from "react";

const InventoryReportDetails = ({ open, close, selectedData }) => {
  //   console.log("SELECTED: ", selectedData);
  const dataSet = JSON.parse(selectedData.stored_data);

  return (
    <Drawer
      title="Inventory Report Details"
      width={window.innerWidth > 400 ? 400 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          marginBottom: 10,
        }}
      >
        <Typography>
          Start:{" "}
          <span style={{ fontWeight: "bold" }}>
            {moment(selectedData.start_datetime).format("lll")}
          </span>
        </Typography>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          marginBottom: 10,
        }}
      >
        <Typography>
          End:{" "}
          <span style={{ fontWeight: "bold" }}>
            {moment(selectedData.end_datetime).format("lll")}
          </span>
        </Typography>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          marginBottom: 10,
        }}
      >
        <Typography>
          Status:{" "}
          <span style={{ fontWeight: "bold" }}>
            {selectedData.remarks === "beginning" ? "BEGINNING" : "ENDING"}
          </span>
        </Typography>
      </div>
      <Divider />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          marginBottom: 10,
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "calc(100% / 2)",
            fontWeight: "bold",
          }}
        >
          PRODUCT
        </div>
        <div
          style={{
            display: "flex",
            width: "calc(100% / 2)",
            justifyContent: "end",
            fontWeight: "bold",
          }}
        >
          ACTUAL
        </div>
        {/* <div
          style={{
            display: "flex",
            width: "calc(100% / 3)",
            justifyContent: "end",
            fontWeight: "bold",
          }}
        >
          AVAILABLE
        </div> */}
      </div>
      <Divider />

      {dataSet.length > 0 &&
        dataSet.map((data, index) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              marginBottom: 10,
              width: "100%",
            }}
            key={index}
          >
            <div
              style={{
                display: "flex",
                width: "calc(100% / 2)",
              }}
            >
              <Typography style={{ fontWeight: "bold" }}>
                {data.product}
              </Typography>
            </div>
            <div
              style={{
                display: "flex",
                width: "calc(100% / 2)",

                justifyContent: "end",
              }}
            >
              {data.quantity}
            </div>
            {/* <div
              style={{
                display: "flex",
                width: "calc(100% / 3)",
                justifyContent: "end",
              }}
            >
              {data.available}
            </div> */}
          </div>
        ))}
    </Drawer>
  );
};

export default InventoryReportDetails;
